import React, { Component, useState } from "react";
import { Menu } from "antd";
import BasicLayout from "../../layouts/basic/BasicLayout";
import style from "./report.module.less";
import MerchantDayReport from "./MerchantDayReport";
import MerchantMonthReport from "./MerchantMonthReport";

const MerchantReport = () => {
    const [currentKey, setCurrentKey] = useState("day");

    const handleClick = (e) => {
        setCurrentKey(e.key);
    };

    const Report = () => {
        return currentKey == "day" ?  <MerchantDayReport/> : <MerchantMonthReport />;
    }

    return (
        <BasicLayout>
            <Menu
                onClick={handleClick}
                selectedKeys={[currentKey]}
                mode="horizontal"
                className={style.menu}
                style={{ marginBottom: 15}}
            >
                <Menu.Item key="day" className={style.item}>商户收入日报</Menu.Item>
                <Menu.Item key="month" className={style.item}>商户收入月报</Menu.Item>
            </Menu>
            <Report/>
        </BasicLayout>
    );
};

export default MerchantReport;
